import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useProfile } from "../context/ProfileContext";
import { BodyMeasurementsCard } from "../components/BodyMeasurementsCard";
import { NewsletterBanner } from "../components/NewsletterBanner";
import { AppWaitlistSection } from "../components/AppWaitlistSection";
import { HeroSlideshow } from "../components/home/HeroSlideshow";
import { HeroSearchPanel } from "../components/home/HeroSearchPanel";
import { StoresStrip } from "../components/home/StoresStrip";
import { HowItWorksSection } from "../components/home/HowItWorksSection";
import { ShopTheLookSection } from "../components/home/ShopTheLookSection";
import { FeaturedDropsSection } from "../components/home/FeaturedDropsSection";

export const Home = () => {
    const [products, setProducts] = useState([]);
    const [stores, setStores] = useState([]);
    const [outfits, setOutfits] = useState([]);
    const { profileId, profile } = useProfile();

    useEffect(() => {
        api.get("/products").then((r) => setProducts(r.data.slice(0, 8))).catch(() => {});
        api.get("/stores", { params: { active: true } }).then((r) => setStores(r.data)).catch(() => {});
        api.get("/outfits", { params: { featured: true, ...(profileId ? { profile_id: profileId } : {}) } })
            .then((r) => setOutfits((r.data || []).slice(0, 3)))
            .catch(() => {});
    }, [profileId]);

    return (
        <div data-testid="home-page" className="bg-[#FDFBF7]">
            <NewsletterBanner />
            <section className="border-b-2 border-black">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch">
                    <HeroSearchPanel
                        profileId={profileId}
                        profile={profile}
                        storeCount={stores.length}
                    />
                    <div className="lg:col-span-5 grid grid-rows-2 gap-6">
                        <HeroSlideshow />
                        <BodyMeasurementsCard profile={profile} />
                    </div>
                </div>
            </section>

            <StoresStrip stores={stores} />
            <HowItWorksSection profileId={profileId} />
            <ShopTheLookSection outfits={outfits} />
            <FeaturedDropsSection products={products} />
            <AppWaitlistSection source="home_hero" />
        </div>
    );
};
